import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import {
  useNotify,
  useRedirect,
  useDataProvider,
  Button,
  Confirm,
} from "react-admin";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { removeHelpPageContentFile } from "../../../utils/fileUtils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

const DeleteButtonWithConfirm = ({
  setLoading,
  loading,
  record,
  resource,
  className,
  basePath,
  ...props
}) => {
  const classes = useStyles();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      await dataProvider.update(resource, {
        id: record.id,
        data: { ...record, active: "false", isLive: false, kbContent: null },
        previousData: record,
      });

      await removeHelpPageContentFile(record);
      notify("File status updated successfully", "success");
      redirect(basePath);
    } catch (err) {
      logError("DeleteButtonWithConfirm:handleUpdate", err, notify);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={loading}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title="Update Confirmation"
        content="Are you sure you want to delete this File?"
        onConfirm={handleUpdate}
        onClose={handleDialogClose}
      />
    </>
  );
};

export default DeleteButtonWithConfirm;
